import { ApiHosts, handleResponseWithNon200Errors, makeGet } from '../../api/helpers';
import { ArticleSummary } from '../article/article.types';
import { ArticleLinksRequestParams, ArticleLinksSearchQueryKey } from './articleLinks.types';

export const normalizeArticleLinksResponse = (response: unknown): ArticleSummary[] =>
    Array.isArray(response) ? (response as ArticleSummary[]) : [];

/**
 * Searches seo-content-service for related guide articles by brand, category, or keyword.
 */
export const searchArticleLinks = async ({
    deployment,
    brand,
    category,
    keyword,
    searchLimit,
}: ArticleLinksRequestParams): Promise<ArticleSummary[]> => {
    const searchQuery = brand
        ? { [ArticleLinksSearchQueryKey.Brand]: brand }
        : category
          ? { [ArticleLinksSearchQueryKey.Category]: category }
          : { [ArticleLinksSearchQueryKey.Keyword]: keyword };

    return new Promise((resolve, reject) => {
        const request = makeGet({
            apiPath: `search`,
            deployment,
            path: ApiHosts.Articles,
            queryParams: { ...searchQuery, searchLimit },
            useCacheKey: false,
        });
        request.end((err, response) => {
            handleResponseWithNon200Errors({
                err,
                reject,
                request,
                resolve: (articles: unknown) => resolve(normalizeArticleLinksResponse(articles)),
                response,
            });
        });
    });
};
